const InsultsList = [
    "Make the logo bigger.",
    "Can you make this red more red?",
    "Play with the fonts, please.",
    "Make it pop.",
    "Move the logo a bit to the left.",
    "It looks kinda boring.",
    "It’s not the final version, right?",
    "My grandson can design better.",
    "I want something like Apple.",
    "Do you work for exposure?",
    "Can you make the logo bigger?",
    "Anyone can design.",
    "Let me show you my design…",
    "We can play with UI later.",
    "We can fix the design later.",
    "I liked the previous version better.",
    "Can you just copy Facebook?",
    "Can you make it more creative?",
    "All good, but a few minor changes. *proceeds to changing everything*.",
    "We need the UIs now, can you quickly put it together?",
    "Why can’t I scroll the sidebar on this PNG?",
    "Oh, one last thing…",
    "My grandson is a designer, too, and he’s got an idea…",
    "You can learn how to be a designer in 5 days.",
    "We need to change something. I don’t know what, but I can feel it..",
    "Our Marketing Team has decided that we don’t need this feature.",
    "Why are you charging so much? My son does logos, too, and he works for free.",
    "Please come to the office to join our Zoom call.",
    "You’re a UX designer, right? Can you draw me a logo?",
    "Can we just start from the beginning?",
    "Let’s stay with the current version.",
    "We already know what our users want.",
    "We don’t have the budget for research.",
    "We need a focus group to test this single page.",
    "Just quickly put it together, we need to pass it over to the engineers.",
    "Looks a bit empty, can we fill in this white space?",
    "It will only take you a couple of minutes.",
    "*Detaches components*.",
    "Our corporate fonts are Helvetica, Roboto, and Open Sans.",
    "No need to test, let our CEO pick the best design.",
    "Can we have it ASAP?",
    "Just help me visualise it.",
    "I don't like the way it looks.",
    "Can you just make it look more modern?",
    "I don’t think it’s user-friendly.",
    "This is too complex. Can you simplify it?",
    "I like this interface I found on Dribbble, can you do something similar?",
    "I don't have time to explain the user's needs. Just make it work.",
    "I don't care about accessibility. Just make it look good.",
    "I don't want to see any wireframes or prototypes. Just show me the final design.",
    "I don't want to follow any design standards or guidelines. Just make it unique.",
    "No need to consider mobile users. Just make it for desktop.",
    "Just make it cool.",
    "I like your solution, but we don’t have time to build it.",
    "It’s just a couple of buttons and a text block, how hard can it be?",
    "We need it yesterday.",
    "Our CEO loves red, can you make it all red instead?",
    "We don’t have time for a prototype. Let’s build first."
]

export default InsultsList